const GAMES_CLOUD_BASE = (process.env.REACT_APP_GAMES_CLOUD_URL || "")
    .replace(/^ws/, "http")
    .replace(/ws$/, "");

export function logActivity(action, details = "") {
    const token = localStorage.getItem("accessToken");
    if (!token || !GAMES_CLOUD_BASE) return;
    fetch(`${GAMES_CLOUD_BASE}activity`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ action, details }),
    }).catch(() => {});
}

// Use sendBeacon for events fired during page unload (beforeunload/visibilitychange)
// sendBeacon is guaranteed to send even as the page is closing, unlike fetch.
export function logActivityBeacon(action, details = "") {
    const token = localStorage.getItem("accessToken");
    if (!token || !GAMES_CLOUD_BASE) return;
    const payload = JSON.stringify({ action, details });
    const blob = new Blob([payload], { type: "application/json" });
    navigator.sendBeacon(
        `${GAMES_CLOUD_BASE}activity?token=${encodeURIComponent(token)}`,
        blob
    );
}
